import cssVariables from 'Lib/cssVariables';

import QueryComponent from './QueryComponent';

const { mobileBreakpoint } = cssVariables;

type Props = React.PropsWithChildren<{
  className?: string;
}>;

const TabletAndDesktop = (props: Props) => (
  <QueryComponent query={`(min-width: ${mobileBreakpoint}px)`}>{props.children}</QueryComponent>
);

export default TabletAndDesktop;
